export default __webpack_public_path__ + "static/brand_04-82ccae01f4fc6258b17b466b02e27097.png";